import React from 'react';
import {Icon, Color} from '@pexip/components';

export const IndicatorIcon: React.FC<
    Omit<React.ComponentProps<typeof Icon>, 'color' | 'size'>
> = props => <Icon color={Color.Neutral70} size="compact" {...props} />;
